import apiClient from "./apiClient";

const officesEndpoint = "/offices";

export const getAllOffices = async () =>
  apiClient.get(`${officesEndpoint}/getAll`).then((res) => res.data);

export const createOffice = async (data) =>
  apiClient.post(`${officesEndpoint}/create`, data).then((res) => res.data);

export const updateOffice = async (id, data) =>
  apiClient
    .patch(`${officesEndpoint}/update/${id}`, data)
    .then((res) => res.data);

export const deleteOffice = async (id) =>
  apiClient.delete(`${officesEndpoint}/delete/${id}`).then((res) => res.data);
